module.exports = __webpack_public_path__ + "img/activite.ec1c1973.jpg";